import { useEffect, useRef, useState } from "react";
import GameInProgressStyles from '../../GameInProgress/GameInProgress.module.css'
import Styles from './Sandbox.module.css';

import LobbyStyles from "../../Lobby/Lobby.module.css";
import logoCompany from '../../../assets/logo-company.png';
import popSound from "../../../assets/audios/pop.mp3";

import { MediaCaptureProvider } from "../../context/MediaCaptureContext";
import AudioRecorderComponent from "../../Media/MediaComponent/AudioRecorderComponent";
import VideoRecorderComponent from "../../Media/MediaComponent/VideoRecorderComponent";
import { getFileType } from "../../../utils/mediaUtils";
import TakePhotoComponent from "../../Media/MediaComponent/TakePhotoComponent";
import ControlledMediaPlayer from "../../Media/MediaPlater/ControlledMediaPlayer";
import { RECORDING_MODE } from "../../../utils/constants";

import "../../Qualification/Qualification.css";
import icoQOff from '../../../assets/ico-q-off.svg';
import icoQOn from '../../../assets/ico-q-on.svg';

import CloseCaptionButton from "../../Buttons/CloseCaptionButton";
import SyncedSubtitle from "../../Subtitles/SyncedSubtitle";
import SubtitleRenderer from "../../Subtitles/SubtitleRenderer";
import LoadingDoorComponent from "../../LoadingDoor/LoadingDoorComponent";
import QuestionTextContainer from "../../QuestionComponent/QuestionTextContainer/QuestionTextContainer";
import { QuestionTypes } from "../../../utils/types";
import MultipleChoice from "../../QuestionComponent/MultipleChoice";
import { getBorderColorByCardType } from "../../../utils/styleUtils";
import PlayerCard from "../../PlayerCard/PlayerCard";
import { formatTime } from "../../../utils/formatUtils";
import InGameHeader from "../../in-game/InGameHeader";

const mockGameState = {
    gameName: "Un titulo exageradamente largo para probar el tema",
    companyLogo: "https://png.pngtree.com/png-clipart/20190604/original/pngtree-corporate-image-logo-png-image_1026060.jpg",
    playersToStart: 3,
    players: [
        {
            id: "1",
            playerName: "Jugador 1",
            status: ""
        },
        {
            id: "2",
            playerName: "Jugador 2",
            status: ""
        },
        {
            id: "3",
            playerName: "Jugador 3",
            status: ""
        },
    ],
    current_question: {
        id: "MOCK_AUDIO",
        module: "1",
        tiempoRespuesta: 60,
        challenge: "Cuando hablamos de los principios básicos de higiene en la manipulación, preparación, elaboración, envasado, estamos haciendo referencia a las Buenas Prácticas de Almacenamiento - BPA.",
        respuestaCorrecta: false,
        feedbackFalsoVerdadero: "Buenas Prácticas de Manufactura",
        tipoDesafio: "soloTexto",
        esFalsoVerdadero: true,
        company: "oSO5DqPaHtsP7moxREr0",
        cardType: QuestionTypes.CONOCIMIENTO,
        room: "1",
        tipoRespuesta: "audio",
        url: [
            // testVideoSource
        ],
        respuestas: [
            "Respuesta #1",
            "Respuesta #2",
            "Respuesta #3",
            "Respuesta #4",
        ]
    },
    questions: [
        {

        }
    ],
    current_answer_qualification: {
        answer: ""
    },
    greetings: {
        begin_game: "Es momento de aprender jugando. ¡Comencemos!"
    }
}

const Sandbox = () => {
    const timer = 120;
    const dropdownOptions = [
        {
            label: "Texto",
            value: "text"
        },
        {
            label: "Audio",
            value: "audio"
        },
        {
            label: "Video",
            value: "video"
        },
        {
            label: "Foto",
            value: "photo"
        },
        {
            label: "Lobby",
            value: "lobby"
        },
        {
            label: "Reproducir audio",
            value: "audio-player"
        },
        {
            label: "Calificación",
            value: "rate-answer"
        },
    ]
    const [selectedOption, setSelectedOption] = useState("");
    const audioRef = useRef();
    const videoRef = useRef();

    const [animated, setAnimated] = useState(false);
    const isOwnAnswer = false;
    const isConfirmed = false;
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);

    const [selectedTextAnswer, setSelectedTextAnswer] = useState("");
    const [borderColor, setBorderColor] = useState("");
    const [hideWelcomeText, setHideWelcomeText] = useState(true);
    const [hideCurtains, setHideCurtains] = useState(true);

    const handleConfirm = (isAnimating = 1) => {
        if (isAnimating) {
            setAnimated(false);
        }
    };

    const toggleCurtain = () => {
        setHideCurtains(prev => !prev);
        if (hideCurtains) {
            setTimeout(() => {
                setHideWelcomeText(false);
            }, 1300);
        } else {
            setHideWelcomeText(true);
        }
    }

    useEffect(() => {
        if (selectedOption === "rate-answer") {
            setRating(0);
            setAnimated(true);
        }
    }, [selectedOption])

    // =================================================================
    // Subtitles code
    // =================================================================
    const [subtitle, setSubtitle] = useState('');
    const [isCCActive, setIsCCActive] = useState(false);
    const toggleCC = () => {
        if (isCCActive) {
            setSubtitle('');
        }
        setIsCCActive(!isCCActive);
    };
    const handleSubtitleChange = (text) => {
        if (isCCActive) {
            setSubtitle(text);
        }
    }
    // =================================================================

    const handleSelectOption = (option) => {
        setSelectedOption(option);
        const cardTypeMap = {
            text: QuestionTypes.CONOCIMIENTO,
            audio: QuestionTypes.TALENTO,
            video: QuestionTypes.TALENTO,
            photo: QuestionTypes.TALENTO,
        }
        setBorderColor(getBorderColorByCardType(cardTypeMap[option]))
        if (option === "lobby") {
            setPlayers(mockGameState.players);
        }
    }

    // =================================================================
    // Lobby methods
    // =================================================================
    const [players, setPlayers] = useState(mockGameState.players);
    const handleReady = () => {
        // pick a random player 
        const randomPlayer = players[Math.floor(Math.random() * players.length)];
        setPlayers(prevPlayers => prevPlayers.map(p => p.id === randomPlayer.id ? { ...p, status: p.status === "" ? "ready" : "" } : p));

        // play a pop sfx
        const sound = new Audio(popSound);
        sound.play();
    };
    // =================================================================

    return (
        <div className={Styles.sandboxContainer}>
            {selectedOption !== "lobby" &&
                <div id="clouds">
                    <div className="cloud x1"></div>
                    <div className="cloud x2"></div>
                    <div className="cloud x3"></div>
                    <div className="cloud x4"></div>
                    <div className="cloud x5"></div>
                </div>}

            {/* curtains + welcome text */}
            <>
                <LoadingDoorComponent open={hideCurtains} />
                {!hideWelcomeText &&
                    <div className="absolute w-full h-full z-10 flex flex-col items-center justify-center">
                        <QuestionTextContainer
                            text={mockGameState.greetings.begin_game} />
                    </div>
                }
            </>

            {selectedOption === "lobby" && (
                <div className={LobbyStyles.lobby} style={{ zIndex: 101 }}>
                    <div className={LobbyStyles.lobbyContainer}>
                        <InGameHeader
                            brandLogo={mockGameState.companyLogo !== '' ? mockGameState.companyLogo : logoCompany}
                            title={mockGameState.gameName}
                            subtitle={`Módulo: Un nombre extremadamente largo para probar que se adapta al espacio ${mockGameState.current_question.module}`}
                        />
                        <div className={LobbyStyles.contPlayer}>
                            {Array.from({ length: Math.max(mockGameState.playersToStart, players.length) }).map((_, index) => {
                                const player = players[index];
                                return player ? (
                                    <PlayerCard key={player.id} player={player} isRanking={false} />
                                ) : (
                                    <PlayerCard key={`empty-${index}`} player={null} isRanking={false} disabled />
                                );
                            })}
                        </div>
                        <div className={LobbyStyles.playersCount}>
                            <label>{players.length}/{mockGameState.playersToStart}</label>
                        </div>

                        <div className={LobbyStyles.generalContainerBorder}>
                            <div className={LobbyStyles.generalContainer}>
                                <label className={LobbyStyles.textTimer}>El juego comienza en</label>
                                {/* Timer */}
                                <div className={LobbyStyles.timer}>{formatTime(timer)}</div>

                                <button className={LobbyStyles.borderPrincipalBtn}
                                    onClick={handleReady}>
                                    <div className={LobbyStyles.principalBtn}>
                                        Estoy listo
                                    </div>
                                </button>


                            </div>
                        </div>
                    </div>
                </div>
            )}

            {selectedOption !== "lobby" &&
                <div className={GameInProgressStyles.screen}>
                    <div className={GameInProgressStyles.curtain}>
                        <div className={GameInProgressStyles.zigZagLineV}> </div>
                    </div>

                    <div className={GameInProgressStyles.gameInProgress}>

                        {/* question component flow */}
                        <div className="question-container">
                            {["video", "audio", "photo", "text"].includes(selectedOption) &&
                                <QuestionTextContainer
                                    text={mockGameState.current_question.challenge}
                                    style={{ borderColor }}
                                    displayHeader
                                    challengeType={mockGameState.current_question.cardType}
                                />
                            }
                            {selectedOption === "audio" &&
                                <MediaCaptureProvider defaultMediaUrl={mockGameState.current_answer_qualification.answer || ""} mode={RECORDING_MODE.audio}>
                                    <AudioRecorderComponent timer={timer} submitDisabled={mockGameState.current_answer_qualification.answer.length > 0} onConfirmAudio={async (url, blob) => {
                                        console.log("url", url, "blob", blob);
                                        // uploadFile(blob, "audio-recording");
                                    }} />
                                </MediaCaptureProvider>}
                            {selectedOption === "video" &&
                                <MediaCaptureProvider defaultMediaUrl={mockGameState.current_answer_qualification.answer || ""}>
                                    <VideoRecorderComponent timer={timer} submitDisabled={mockGameState.current_answer_qualification.answer.length > 0} onConfirmVideo={async (url, blob) => {
                                        console.log("url", url, "blob", blob);
                                        // uploadFile(blob, "video-recording");
                                    }} />
                                </MediaCaptureProvider>}
                            {selectedOption === "photo" &&
                                <MediaCaptureProvider mode={RECORDING_MODE.photo} submitDisabled={mockGameState.current_answer_qualification.answer.length > 0} >
                                    <TakePhotoComponent timer={timer} submitDisabled={mockGameState.current_answer_qualification.answer.length > 0} onConfirmPhoto={async (url, blob) => {
                                        console.log("url", url, "blob", blob);
                                        // uploadFile(blob, "photo");
                                    }} />
                                </MediaCaptureProvider>}
                            {selectedOption === "text" &&
                                <MultipleChoice
                                    question={mockGameState.current_question}
                                    setAnswer={setSelectedTextAnswer}
                                    answer={selectedTextAnswer}
                                />
                            }
                        </div>

                        {/* partial answer component */}
                        {selectedOption === "audio-player" &&
                            <div className="w-full fix-left-on-mobile flex items-center justify-center">
                                <ControlledMediaPlayer
                                    ref={audioRef}
                                    mediaUrl={mockGameState.current_answer_qualification}
                                />
                            </div>}

                        {/* rate answer */}
                        {selectedOption === "rate-answer" &&
                            <div className="queContainer">
                                <div className={`blockContent ${animated ? "show" : ""}`}>

                                    <div className={`TextboxContainer`}>
                                        <div className="Textbox">
                                            <div>
                                                <label>{mockGameState.current_question.challenge}</label>
                                                {/* Verificar si hay al menos una URL */}
                                                {mockGameState.current_question.url && mockGameState.current_question.url.length > 0 && (
                                                    <div className="media-gallery">
                                                        {(() => {
                                                            const mediaUrl = mockGameState.current_question.url[0];
                                                            const fileType = getFileType(mediaUrl);

                                                            if (fileType === "image") {
                                                                return <img src={mediaUrl} alt="Imagen de la pregunta" className="question-image" />;
                                                            } else if (fileType === "video") {
                                                                return <div className="flex items-center justify-center">
                                                                    <SyncedSubtitle ref={videoRef} onCloseCaptionChange={handleSubtitleChange} />
                                                                    <SubtitleRenderer text={subtitle} isActive={isCCActive} isAbsolute />
                                                                    <video ref={videoRef} src={mediaUrl} controls className="question-video" />
                                                                </div>;
                                                            } else {
                                                                return <p className="unsupported-media">Tipo de archivo no soportado</p>;
                                                            }
                                                        })()}
                                                    </div>
                                                )}
                                            </div>

                                            {
                                                <div className="textNotQualification">
                                                    <label><b style={{ fontWeight: '700', fontSize: '23px', color: '#00b6ff' }}>Los demás viajeros están calificando tu respuesta</b></label>
                                                </div>}
                                        </div>
                                    </div>

                                    <div className="mediaContainer">

                                        {!isOwnAnswer && mockGameState.current_answer_qualification &&
                                            <div className="center">
                                                {mockGameState.current_answer_qualification.answer === "no_answer" &&
                                                    <div className="whitebox-purple-border">
                                                        <p>¡Oh! Un viajero no respondió a tiempo</p>
                                                    </div>}

                                                {mockGameState.current_question.tipoRespuesta === "foto" &&
                                                    <div className="flex items-center justify-center">
                                                        <img src={mockGameState.current_answer_qualification.answer} alt="Respuesta del usuario" className="image-box" />
                                                    </div>}

                                                {mockGameState.current_question.tipoRespuesta === "video" &&
                                                    <div className="flex items-center justify-center">
                                                        <SyncedSubtitle ref={videoRef} onCloseCaptionChange={handleSubtitleChange} />
                                                        <SubtitleRenderer text={subtitle} isActive={isCCActive} isAbsolute />
                                                        <video className="video-box" ref={videoRef} autoPlay src={mockGameState.current_answer_qualification.answer} controls />
                                                    </div>}

                                                {mockGameState.current_question.tipoRespuesta === "audio" &&
                                                    <div className="flex flex-col justify-center gap-1">
                                                        <SyncedSubtitle ref={audioRef} onCloseCaptionChange={handleSubtitleChange} />
                                                        <SubtitleRenderer text={subtitle} isActive={isCCActive} />
                                                        <div className="flex items-center justify-center">
                                                            <ControlledMediaPlayer ref={audioRef} mediaUrl={mockGameState.current_answer_qualification.answer} />
                                                        </div>
                                                    </div>}

                                                {mockGameState.current_question.tipoRespuesta === "texto" && mockGameState.current_answer_qualification.answer !== "no_answer" &&
                                                    <div className="whitebox-purple-border">
                                                        <p className="answer-text">{mockGameState.current_answer_qualification.answer}</p>
                                                    </div>}
                                            </div>}

                                        {!isOwnAnswer && !mockGameState.current_answer_qualification &&
                                            <div className="whitebox-purple-border">
                                                <p>No hay respuestas para calificar</p>
                                            </div>}

                                        {!isOwnAnswer && mockGameState.current_answer_qualification && mockGameState.current_answer_qualification.answer !== "no_answer" &&
                                            <div className="center">
                                                <div className="rating-stars yellowbox-purple-border">
                                                    {[...Array(5)].map((_, index) => {
                                                        const ratingValue = index + 1;
                                                        return (
                                                            <label key={index}>
                                                                <input type="radio" name="rating" value={ratingValue} onClick={() => setRating(ratingValue)} disabled={isConfirmed} />
                                                                <img className="star" src={ratingValue <= (hover || rating) ? icoQOn : icoQOff} alt="logo game" onMouseEnter={() => setHover(ratingValue)} onMouseLeave={() => setHover(0)} />
                                                            </label>
                                                        );
                                                    })}
                                                </div>

                                                <button className="ConfirmButton" onClick={handleConfirm} disabled={rating === 0 || isConfirmed}>
                                                    <div className="principalBtn">
                                                        {isConfirmed ? 'Enviado' : 'Enviar'}
                                                    </div>
                                                </button>
                                            </div>}
                                    </div>
                                </div>

                                <div className={`slideContent ${!animated ? "show-greeting" : ""}`}>
                                    <div className={`TextboxContainer`}>
                                        <div className="Textbox">
                                            <div>
                                                <label>Gracias por calificar</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}

                        {selectedOption === "text" && (
                            <button className="ConfirmButton" onClick={() => { }}>
                                <div className="principalBtn">
                                    Enviar
                                </div>
                            </button>
                        )}
                    </div>
                </div>}

            <CloseCaptionButton isActive={isCCActive} onClick={toggleCC} />

            {/* dropdown component picker */}
            <div className={Styles.pickComponentContainer}>
                <label htmlFor="componentPicker">{`Elegir componente: `}</label>
                <select
                    name="componentPicker"
                    id="componentPicker"
                    value={selectedOption}
                    onChange={e => handleSelectOption(e.target.value)}>
                    <option value="" >Seleccionar...</option>
                    {dropdownOptions.map((option, index) => (
                        <option
                            key={`option_${index}_${option.value}`}
                            value={option.value}
                        >
                            {option.label}
                        </option>
                    ))}
                </select>
                <button className={Styles.curtainButton} onClick={toggleCurtain}>
                    {hideCurtains ? "Abrir" : "Cerrar"} cortinas
                </button>
            </div>
        </div>
    )
}

export default Sandbox